import { Form as e } from "formik";
import o from "styled-components";
import { device as t } from "../../utils/device.js";
const r = o.div`
  display: flex;
  height: 100%;

  @media ${t.isMobile}, ${t.isTablet} {
    flex-direction: column;
    padding: 20px;
  }
`, d = o.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`, l = o(e)`
  height: 100%;
`, s = o.button`
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
`;
export {
  d as ComponentWrapper,
  r as ContentWrapper,
  l as FormWrapper,
  s as HiddenButton
};
